import { render, staticRenderFns } from "./PerformanceUnitLoginView.vue?vue&type=template&id=8bdd967a&scoped=true"
import script from "./PerformanceUnitLoginView.vue?vue&type=script&lang=ts"
export * from "./PerformanceUnitLoginView.vue?vue&type=script&lang=ts"
import style0 from "./PerformanceUnitLoginView.vue?vue&type=style&index=0&id=8bdd967a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdd967a",
  null
  
)

export default component.exports